<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>Ad Slots | Amortization Calculator</h2>
        <p class="hint">
          These are products that will be displayed when a user uses the amortization calculator. The ad slots will be displayed one at a time and rotated equally.
        </p>
      </v-card-title>

      <v-card-text>
        <div
          v-for="i in 3"
          :key="i"
          class="mb-5">
          <h4>Slot {{ i }}</h4>

          <div class="input-group">
            <v-select
              label="Unused"
              v-model="selectedProducts[i - 1]"
              :items="selectedProducts[i - 1] ? productOptions : filteredProductOptions"
              :disabled="!!selectedProducts[i - 1]"
              single-line
              solo
              hide-details
              @input="createAdSlot(i, $event)"
            />

            <button
              v-if="selectedProducts[i - 1]"
              class="default-btn red minimal"
              @click="clearAdSlot(i)"
            >Clear Ad Slot</button>
          </div>

          <dl
            class="grid-wrapper ad-data"
            v-if="selectedProducts[i - 1]"
          >
            <dt>Shown to users:</dt>
            <dd>{{ getAdData(i, 'displayCount') }}</dd>

            <dt>Hot leads generated:</dt>
            <dd>{{ getAdData(i, 'leadCount') }}</dd>
          </dl>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FeaturedProductsAmortization',
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    adsAmortization: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedProducts: [],
  }),

  computed: {
    productOptions () {
      return this.products
        .map(product => ({
          value: product.id,
          text: product.internalName || `${product.title} (${product.loanType || 'No preference'})`,
        }))
    },

    filteredProductOptions () {
      return this.productOptions.filter(({ value }) => {
        return !this.selectedProducts.includes(value)
      })
    },
  },

  watch: {
    adsAmortization () { this.setSelectedProducts() },
  },

  mounted () {
    this.setSelectedProducts()
  },

  methods: {
    getAdData (slot, field) {
      const ad = this.adsAmortization.find(({ slotNumber }) => {
        return slotNumber === slot
      })

      return ad ? ad[field] : 0
    },

    setSelectedProducts () {
      this.selectedProducts = [...Array(3)].map(() => undefined)
      for (const ad of this.adsAmortization) {
        this.selectedProducts[ad.slotNumber - 1] = ad.productId
      }
    },

    createAdSlot (slotNumber, productId) {
      this.$nextTick(() => {
        this.selectedProducts[slotNumber - 1] = undefined
        this.$forceUpdate()
      })

      this.$emit('create', {
        productId: productId,
        organizationId: this.products.find(({ id }) => id === productId).organizationId,
        type: 'resource_amortization',
        slotNumber,
        active: true,
      })
    },

    clearAdSlot (slot) {
      const id = this.adsAmortization.find(({ slotNumber }) => slotNumber === slot).id

      this.$emit('remove', {
        id,
        type: 'resource_amortization',
        slotIndex: slot - 1,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ad-data {
  margin: 10px 0 10px 20px;

  justify-content: flex-start;
  grid-gap: 2px 5px;

  dt {
    font-weight: bold;
  }
}
</style>
